export default "__VITE_ASSET__Dt0AukFK__"